import { useState } from "react";
import { BooleanField, BooleanInput, Labeled, useNotify, useRefresh, Button } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import dataProvider from "server/dataProvider";
import { candidateRequests } from "api/candidateApi";
import FormModal from "server/components/Modals/FormModal";

const PreparatoryClass = ({ candidacyId, preparatoryClass, isLatestRankingApproved }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [usingPreparatoryClass, setUsingPreparatoryClass] = useState(preparatoryClass);

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      candidateRequests.updateCandidacyPreparatoryClass(candidacyId ?? -5),
      { usingPreparatoryClass },
      "PUT",
    );

    notify("Успешна редакция", { type: "success" });
    refresh();
  };

  return (
    <>
      <Labeled label="Ще ползва подготвителна година">
        <BooleanField source="preparatoryClass" />
      </Labeled>
      <FormModal
        titleContent="Подготвителна година"
        onConfirm={handleSubmit}
        confirmEnabled={preparatoryClass !== usingPreparatoryClass}
        triggerButton={
          <Button
            startIcon={<EditIcon />}
            variant="contained"
            disabled={isLatestRankingApproved}
            label="Редактирай"
          />
        }
      >
        <BooleanInput
          source="usingPreparatoryClass"
          label="Ще ползва подготвителна година"
          defaultValue={preparatoryClass}
          onChange={e => setUsingPreparatoryClass(e.target.checked)}
        />
      </FormModal>
    </>
  );
};

export default PreparatoryClass;
